export default __webpack_public_path__ + "static/media/slide10.0225f716.jpg";